export default __webpack_public_path__ + "static/studio-3a0b5dfa7d7fad8de572e27529e8cb51.jpeg";